<template>
  <button
    class="lg:px-[26px] px-[22px] py-3 bg-cerise-red-600 text-white rounded-3xl text-base !leading-5 tracking-wide"
    :class="disabled ? 'opacity-30 cursor-not-allowed' : ''"
    :disabled="disabled"
    :type="type"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
  },
};
</script>
